import { Modal, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";

export default function CancelOrderReason({ show, onClose, onSubmit }) {
  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.reason.trim()) {
        errors.reason = "Please enter a reason to cancel the order";
      }
      return errors;
    },
    onSubmit: (values, { resetForm }) => {
      onSubmit(values.reason);
      resetForm();
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Cancel Order</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group controlId="cancelReason">
          <Form.Label>Reason for cancellation</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="reason"
            placeholder="Enter cancellation reason"
            value={formik.values.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={formik.touched.reason && !!formik.errors.reason}
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors.reason}
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>

        <Button
          variant="danger"
          onClick={formik.handleSubmit}
          disabled={formik.isSubmitting}
        >
          Confirm Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
